export default __webpack_public_path__ + "static/media/promise.2c39866b.mp3";